// src/services/visitor/visitorApi.ts

import { PrayerFeedResponse } from "@/types/ugc/prayerTypes";
import baseApi from "../../lib/baseApi";
import type { VisitorProfile } from "../../types/profiles/visitorProfileTypes";
import type { MomentFeedResponse } from "../../types/ugc/momentTypes";

// ---------------------------
// Params helper
// ---------------------------
type PageOpts = { page?: number; pageSize?: number };

const withPageParams = (opts?: PageOpts) => {
  const params: Record<string, any> = {};
  if (typeof opts?.page === "number" && opts.page > 0) params.page = opts.page;
  if (typeof opts?.pageSize === "number") params.page_size = opts.pageSize;
  return Object.keys(params).length ? { params } : undefined;
};

// ---------------------------
// Visitor API (read-only)
// ---------------------------
export const visitorApi = {
  // Unified profile: member OR guest
  getProfile: async (username: string) => {
    const { data } = await baseApi.get<VisitorProfile>(
      `/profiles/profile/${username}/`
    );
    return data;
  },

  // Unified moments: member OR guest
  getMoments: async (username: string, opts?: PageOpts) => {
    const { data } = await baseApi.get<MomentFeedResponse>(
      `/profiles/profile/${username}/moments/`,
      withPageParams(opts)
    );
    return data;
  },

  // Prayers remain member-only
  getPrayers: async (username: string, opts?: PageOpts) => {
    const { data } = await baseApi.get<PrayerFeedResponse>(
      `/profiles/members/profile/${username}/prayers/`,
      withPageParams(opts)
    );
    return data;
  },
};

export default visitorApi;